import { Stack } from '@mui/material'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

interface PsvDynamicHeaderProps {
	psv_value: number
	norm_psv_value: number
}

const PsvDynamicHeader = ({ psv_value }: PsvDynamicHeaderProps) => {
	return (
		<>
			<Stack direction='column' gap='8px'>
				<TypographySecondary>Итого за период</TypographySecondary>

				{psv_value != null && (
					<Stack direction='row' alignItems='baseline' gap='4px'>
						<TypographyPrimary16Bold>{psv_value}</TypographyPrimary16Bold>
						<TypographyPrimary>кг/голову</TypographyPrimary>
					</Stack>
				)}

				<TypographySecondary>Среднее потребление</TypographySecondary>
			</Stack>
		</>
	)
}

export default PsvDynamicHeader
